var React = require('react');

function Mountain (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 242.75l-66.66-66.67L293.08 14.7a32 32 0 0 1 53.84 0L460.9 192H306.75l-9.37 9.37z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M636.09 495.33A32 32 0 0 1 608 512H32a32 32 0 0 1-26.92-49.3l166.55-259.07L256 288l64-64h161.47l153.45 238.7a32 32 0 0 1 1.17 32.63z","className":"fa-primary","key":2})]);
}

Mountain.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Mountain;

Mountain.default = Mountain;
